import { TranslationMessages } from 'react-admin';
import englishMessages from 'ra-language-english';
import customEn from './customEn.json';
const customEnglishMessages: TranslationMessages = {
  ...englishMessages,
  ...customEn,
};

export default customEnglishMessages;
